// import components below
import PropTypes from 'prop-types';
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const NursingHeader = ({ active }) => {
  return (
    <div className='admissionHeader'>
      <PageHeaderUI>
        <h4>Nursing Module</h4>
        <p>Dashboard / Nursing / {active}</p>
      </PageHeaderUI>
    </div>
  );
};

NursingHeader.defaultProps = {
  active: '',
};

NursingHeader.propTypes = {
  active: PropTypes.string,
};

export default NursingHeader;
